import React, { useEffect } from 'react';
import { componentKey, setCurrentTabIndex } from "./ReviewRejectedFormSlice";
import { useDispatch, useSelector } from "react-redux";
import { TAB_PATHS } from "./constants";
import TabbedNavigationWithDefinedTitle from "../../../components/tabbednavigation/TabbedNavigationWithDefinedTitle";
import Form1099 from "./1099forms/Form1099";
import commonStyles from "../FormSection.styles";
import ReviewRejectedStatePayrollForms from "./reviewrejectedstatepayrollforms/ReviewRejectedStatePayrollForms";
import { useLocation } from 'react-router-dom';
import { FEATURE_FLAG } from '../../../featureFlags';

function ReviewRejectedForms() {
    
    const dispatch = useDispatch();
    const location = useLocation();
    const { currentTabIndex } = useSelector((state) => state[componentKey]);

    useEffect(() => {

        const paths = location.pathname.split("/");
        const currentPath = paths[paths.length - 1];
        let index = 0;

        switch (currentPath) {
            case TAB_PATHS.$1099_FORMS:
                index = 0;
                break;

            case TAB_PATHS.STATE_PAYROLL_FORMS:
                index = 1;
                break;
        }

        dispatch(setCurrentTabIndex(index));
    }, [location.pathname])

    const tabListWithTitleObj = [
        {
            title: {
                titleText: "Form 1099",
            },
            tabBodyComponent: <Form1099 />,
            linkTo: `/${TAB_PATHS.$1099_FORMS}`,
        },
        ...(FEATURE_FLAG.SHOW_STATE_PAYROLL ? [{
            title: {
                titleText: "State Payroll Forms",
            },
            tabBodyComponent: <ReviewRejectedStatePayrollForms />,
            linkTo: `/${TAB_PATHS.STATE_PAYROLL_FORMS}`,
        }] : []),
    ];

    return (
        <div style={commonStyles.gridContainer}>
            <TabbedNavigationWithDefinedTitle
                tabListWithTitleObj={tabListWithTitleObj}
                useSeparateUrl={true}
                sectionPath={"/forms/reviewrejectedforms"}
                activeTabIndex={currentTabIndex}
                onChangeTabCb={(activeTabIdx) =>
                    dispatch(setCurrentTabIndex(activeTabIdx))
                }
                unMountChildComponentOnSwitch={true}
            />
        </div>
    );
}

export default ReviewRejectedForms;
